// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { DataCache } from "../../Commons/DataCache.ts";
import { Resources } from "../../Commons/properties/Resources.ts";
import { TerceraComboBox } from "./TerceraComboBox.js";

export let TerceraAssetComboBox = TerceraComboBox.extend({
    data: function () { return { allItemVisible: true }; }
});

TerceraAssetComboBox.prototype.oninit = function ()
{
    TerceraComboBox.prototype.oninit.apply(this);
    this.observe('allItemVisible', this.repopulateItems);
};

TerceraAssetComboBox.prototype.repopulateItems = function ()
{
    let items = []
    let assets = DataCache.getAssetDict()
    for (let key in assets)
    {
        let asset = assets[key]
        items.push({ text: asset.Name, value: asset.Id });
    }
    items.sort(TerceraAssetComboBox.compareAssets)

    if (this.get('allItemVisible'))
    {
        items.splice(0, 0, {
            text: Resources.getResource('panel.TerceraSymbolLookupDropDownForm.All'),
            value: 'All'
        })
    }

    this.set('items', items);
}

TerceraAssetComboBox.compareAssets = function (a0, a1)
{
    return a0.text.localeCompare(a1.text);
};